import React from 'react';
import classnames from 'classnames';
import {TooltipProps} from '@mui/material';

import Tooltip from 'src/components/tooltip';
import Icon from 'shared/components/icon';

import 'stylesheets/components/shared-tooltip.scss';

interface Props {
  iconType: string;
  // Size of icon. Defaults to 16.
  iconSize?: number;
  // Callback fired on button click.
  onClick?: () => void;
  // An extra class name for the button that triggers the tooltip.
  className?: string;
  // The contents of the tooltip,
  // e.g. "<div>Includes <em>all</em> of your earnings.</div>"
  children: React.ReactNode;
  // Placement of the tooltip relative to the trigger. Defaults to bottom.
  placement?: TooltipProps['placement'];
  // Apply margin-left style. Defaults to false.
  margin?: boolean;
  testId?: string;
}

const IconTooltip = ({
  iconType,
  iconSize = 16,
  onClick,
  className,
  children,
  placement,
  margin = false,
  testId,
  ...muiTooltipProps
}: Props & Omit<TooltipProps, 'children' | 'title'>) => (
  <Tooltip {...muiTooltipProps} title={children} placement={placement}>
    <button
      className={classnames('shared-tooltip-button', className, {margin})}
      onClick={onClick}
      type="button"
      data-testid={testId}
    >
      <Icon
        iconType={iconType}
        className="shared-tooltip-icon"
        style={{fontSize: `${iconSize}px`}}
      />
    </button>
  </Tooltip>
);

export default IconTooltip;
